export const socials = [
  { name: 'GitHub', icon: 'github', url: 'https://github.com/kdraslan' },
  { name: 'LinkedIn', icon: 'linkedin', url: 'https://www.linkedin.com/in/kdraslan' },
  { name: 'Medium', icon: 'book-open', url: 'https://medium.com/@kdraslan' },
  { name: 'Instagram', icon: 'instagram', url: 'https://instagram.com/kdr.aslan' },
];
